export { default } from './skip-to-content-link';
